import query from 'query-string';
import dayjs from 'services/dayjs';

import { commonStore } from 'stores';
import { COPY, ACCESS } from 'config';

const CardTypes = {
    basic: require('assets/images/cards/card.png'),
    visa: require('assets/images/cards/visa.png'),
    mir: require('assets/images/cards/mir.png'),
    unionpay: require('assets/images/cards/union_pay.png'),
    jcb: require('assets/images/cards/jcb.png'),
    'diners-club': require('assets/images/cards/diners_club.png'),
    elo: require('assets/images/cards/elo.png'),
    hipercard: require('assets/images/cards/hipercard.png'),
    discover: require('assets/images/cards/discover.png'),
    mastercard: require('assets/images/cards/mastercard.png'),
    'american-express': require('assets/images/cards/amex.png'),
    maestro: require('assets/images/cards/maestro.png'),
};

/**
 * Return the required attributes
 * for blank links.
 *
 * @return {object}
 */
export function blankLinkAttributes() {
    return {
        target: '_blank',
        rel: 'noopener noreferrer',
    };
}

/**
 * Return the image for the given
 * card name.
 *
 * @param {string} name
 */
export function str_to_card_image(name) {
    name = name.replace('mc', 'mastercard');
    if (!CardTypes[name]) {
        return CardTypes.basic;
    }

    return CardTypes[name];
}

/**
 * Generate a URL friendly "slug" from
 * the provided text.
 *
 * @param {string} text
 */
export function str_slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
}

/**
 * Encodes the provided string
 *
 * @param {string} s
 */
export function str_b64_encode_unicode(s) {
    return btoa(
        encodeURIComponent(s).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode('0x' + p1);
        }),
    );
}

/**
 * Validate the provided email and make
 * sure is valid.
 *
 * @param {string} email
 */
export function str_validate_email(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

/**
 * Returns the provided text with the first
 * char in uppercase.
 *
 * @param {string} text
 */
export function str_ucfirst(text = '') {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

/**
 * Converts the currency name to its symbol.
 *
 * @param {string} currency
 */
export function str_convert_currency_to_symbol(currency) {
    let value = currency.replace('EUR', '€');

    if (
        (commonStore.userLocation &&
            commonStore.userLocation.country === 'US') ||
        (commonStore.user && commonStore.user.country === 'US')
    ) {
        value = value.replace('USD', '$');
    }

    return value;
}

/**
 * Serialize an object
 *
 * @param {object} data
 */
export function str_serialize(obj) {
    return query.stringify(obj);
}

export function is_campaign_active(name) {
    const campaign = ACCESS[name];
    const starts = dayjs(campaign.campaign_starts);
    const ends = dayjs(campaign.campaign_ends);
    return dayjs().isBetween(starts, ends, 'day', '[)');
}
// A RegExp to check the correct format of an card expiry input
const card_expiry_reg = new RegExp('(0[1-9]|1[0-2])/[0-9]{2}');
/**
 * Valid the expiry info of a credit card
 */
export const is_expiry_valid = (expiry) => {
    if (!expiry || !expiry.match(card_expiry_reg)) {
        return false;
    }
    const [month, year] = expiry.split('/');

    return dayjs().isSameOrBefore(`20${year}-${month}-01`, 'month');
};
/**
 * Generates an array that can be used for the
 * credit card input mask.
 *
 * @param {array} gaps
 * @param {int} maskLength
 */
export function generate_input_mask(gaps, maskLength) {
    if (gaps) {
        let mask = [],
            i = 1;
        for (i; i <= maskLength; i++) {
            mask.push(/\d/);
            if (gaps.indexOf(i) >= 0) {
                mask.push(' ');
            }
        }

        return mask;
    }

    return [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
    ];
}

// this is copied from old-old website.. who knows
// how many years ago was this written?
export function get_download_url() {
    let url = 'https://public.yousician.com/Builds/Yousician';
    let ua = window.navigator.userAgent.toLowerCase();

    if (ua.search('windows') >= 0) {
        url += 'Setup.exe';
    } else {
        url += '.dmg';
    }

    return url;
}

export function float_to_fixed(num) {
    let s = String(num);
    if (s.indexOf('.') < 0) {
        s = `${s}.00`;
    }

    s = s.substring(0, s.indexOf('.') + 3);

    return `${s}`;
}

export function getCongratulationsText(subscription, freeTrial) {
    const licensedContent =
        Boolean(commonStore) && commonStore.userPolicies.licensed_content;

    const licensedCopyKey = subscription.family
        ? 'CONGRATULATIONS_FAMILY'
        : subscription.licensed
        ? 'CONGRATULATIONS_LICENSED'
        : licensedContent
        ? 'CONGRATULATIONS_PREMIUM'
        : 'CONGRATULATIONS_UNLICENSED';

    const instrumentCopyKey = subscription.features.all_instruments
        ? 'ALL_INSTRUMENTS'
        : `${subscription.features.instrument}`.toUpperCase();

    return COPY[licensedCopyKey][instrumentCopyKey][
        freeTrial ? 'TRIAL' : 'SUBSCRIPTION'
    ];
}
